/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { FacetTypes, GrabXDataTypes, GrabXFeatureFlag } from "./types"
import { generateDefaultFacets } from "./facets"

export const EMPTY_VARIABLE_NAME = "empty variable name"

export enum MerchantPortalFeatureFlag {
  markOrdersReadyConfig = "markOrdersReadyConfig",
  enableMenuBulkUpload = "enableMenuBulkUpload",
  enableTroyNewMerchantEndpoint = "enableTroyNewMerchantEndpoint",
  enableMenuTranslationPortal = "enableMenuTranslationPortal",
  enableMenuGroupMenuTranslationPortal = "enableMenuGroupMenuTranslationPortal",
  brandListing = "enableBrandListingTroyPortal",
  mexItemAttributes = "enableMexItemAttributes",
  freeTextItemAttributes = "fedEnableFreeTextItemAttribute",
  numericalItemAttributes = "fedEnableDecimalItemAttribute",
  attributeLocalizationEnabled = "IsAttributeLocalizationEnabled",
  portalRetryTimeout = "portalRetryTimeout",
  enableMexSupplier = "enableMexSupplier",
  // owner: @m.hidayat expected rollout: Oct 2024
  enableMexSupplierHidePII = "enableMexSupplierHidePII",
  enableAlcoholSetting = "SelfServeAlcoholTaggingEnabled",
  enableAlcoholSettingMenuGroupV2 = "SelfServeAlcoholTaggingEnabledForMenuGroupV2",
  enableChangeStoreStatusOnPortal = "enableChangeStoreStatusOnPortal",
  enableEditOrderOnTroyPortal = "enableEditOrderOnTroyPortal",
  mexPortalBulkReviewDownload = "mexPortalBulkReviewDownload",
  enableMerchantReviewThrottle = "fedMerchantReviewThrottleRevampPortal",
  portalCallFetchStoreStatusInterval = "portalCallFetchStoreStatusInterval",
  linkStoreMaxLimit = "linkStoreMaxLimit",
  enablePortalWebp = "enablePortalWebp",
  portalEnableHermesConnection = "portalEnableHermesConnection",
  // owner: @m.hidayat expected rollout: July 2024
  enableSelectMenuGroupSearch = "portalEnableSelectMenuGroupSearch",
  portalEnablePartialMenu = "portalEnablePartialMenu",
  enableTrackError = "enablePortalTrackError",
  // owner: @leyi.song expected rolout: Jan 2025
  TobaccoSaleEnabled = "TobaccoSaleEnabled",
  TobaccoSaleEnabledForMenuGroupV2 = "TobaccoSaleEnabledForMenuGroupV2",
  // owner: @mingkit.luk expected rollout: Nov 2024
  portalReviewsHideOrderIDAndShowOrderItems = "portalReviewsHideOrderIDAndShowOrderItems",
  // owner: @husni.habil expected rollout: Jan 2025
  enableDeeplinkToFinancePage = "enableDeeplinkToFinancePage",
  // owner: @novi.steven expected rollout: Feb 2025
  enableMMEItemEndpointRedesign = "enableMMEItemEndpointRedesignPortal",
  // owner: @novi.steven expected rollout: Feb 2025
  enableMMEItemEndpointRedesignForMenuGroupV2 = "enableMMEItemEndpointRedesignPortalForMenuGroupV2",
  // owner: @muhammad.arfandy expected rollout: March 2025
  enableOPTForReceiptPickupTime = "enableOPTForReceiptPickupTime",
  // owner: @m.hidayat expected rollout: Feb 2025
  portalFeedbackOverviewBatchSize = "portalFeedbackOverviewBatchSize",
  // owner: @benjamin.tanone expected rollout: Jun 2025
  mexPortalEnableIncidents = "mexPortalEnableIncidents",
  // owner: @m.hidayat expected rollout: Mar 2025
  enableMenuV2PartialMigrate = "EnableMenuV2PartialMigrate",
  // owner: @christopher.andreas expected rollout: Mar/Apr 2025
  enableNewHermesDomainFoodMerchantPortal = "enableNewHermesDomainFoodMerchantPortal",
  // owner: @muhammad.arfandy, don't delete after full rollout
  portalDatadogRumConfig = "portalDatadogRumConfig",
  // owner: @husni.habil, don't delete after full rollout
  enableEditorUIBulkUpload = "enableEditorUIBulkUpload",
  // owner: @ashiq.rasool expected rollout: Jun 2025
  mexPortalEnableRatingsWithoutReview = "mexPortalEnableRatingsWithoutReview",
  // owner: @husni.habil expected rollout: Jul 2025
  enableShowItemAndModifierIncidentDetail = "enableShowItemAndModifierIncidentDetail",
  // owner: @husni.habil expected rollout: Jul 2025
  enableAppealIncidentInDrawer = "enableAppealIncidentInDrawer",
  // owner: @novi.steven expected rollout: Oct 2025
  portalEnableBulkUploadProcessingBannerByUploadType = "portalEnableBulkUploadProcessingBannerByUploadType",
  // owner: @muhammad.arfandy expected rollout: Oct 2025, can't be removed after full rollout, its also can be used to check if the store is grab devices store or not
  portalEnableDownloadMpaTransaction = "portalEnableDownloadMpaTransaction",
  // owner: @m.hidayat expected rollout: Oct 2025
  enableImageResizeOnUpload = "portalEnableImageResizeOnUpload",
  // owner: @novi.steven expected rollout: Oct 2025
  portalEnableBulkUploadEditRestriction = "portalEnableBulkUploadEditRestriction",
  // owner: @m.hidayat expected rollout: Oct 2025
  portalEnableMenuItemSearch = "portalEnableMenuItemSearch",
  // owner: @novi.steven
  portalEnableGrabMexProImageEditor = "portalEnableGrabMexProImageEditor",
  // owner: @novi.steven
  portalEnableImageFetchRetry = "portalEnableImageFetchRetry",
  // owner: @m.hidayat expected rollout: Jan 2025
  enableCatalogStoreForMenuGroup = "portalEnableCatalogStoreForMenuGroup",
  // owner: @wesley.loh expected rollout: Feb 2026
  portalEnableHideItem = "portalEnableHideItem",
}

// list of grabX variable to be pulled
export const GRABX_FLAG_LIST: GrabXFeatureFlag[] = [
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableMenuBulkUpload,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.mexItemAttributes,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.freeTextItemAttributes,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.numericalItemAttributes,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.brandListing,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.attributeLocalizationEnabled,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.portalRetryTimeout,
    dataType: GrabXDataTypes.Number,
    defaultValue: 0,
  },
  {
    grabxVariableName:
      MerchantPortalFeatureFlag.portalFeedbackOverviewBatchSize,
    dataType: GrabXDataTypes.Number,
    defaultValue: 400,
  },
  {
    grabxVariableName:
      MerchantPortalFeatureFlag.enableChangeStoreStatusOnPortal,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableMerchantReviewThrottle,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName:
      MerchantPortalFeatureFlag.portalCallFetchStoreStatusInterval,
    dataType: GrabXDataTypes.Number,
    defaultValue: 60000,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.linkStoreMaxLimit,
    dataType: GrabXDataTypes.Number,
    defaultValue: 50,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enablePortalWebp,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableSelectMenuGroupSearch,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableTrackError,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.mexPortalEnableIncidents,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableOPTForReceiptPickupTime,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
    facets: {
      ...generateDefaultFacets(),
      [FacetTypes.ServiceName]: "mex-portal",
    },
  },
  {
    grabxVariableName:
      MerchantPortalFeatureFlag.enableNewHermesDomainFoodMerchantPortal,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName:
      MerchantPortalFeatureFlag.enableShowItemAndModifierIncidentDetail,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableAppealIncidentInDrawer,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableImageResizeOnUpload,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName:
      MerchantPortalFeatureFlag.portalEnableBulkUploadEditRestriction,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.portalEnableImageFetchRetry,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.portalEnableHideItem,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
]
